import React from 'react';
import { List, Datagrid, Filter, TextField, TextInput } from 'react-admin';

const SchoolFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const SchoolList = props => (
  <List filters={<SchoolFilter />} {...props} exporter={false} >
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="address" />
      <TextField source="contactPhone" />
    </Datagrid>
</List>
);

export default SchoolList
